/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Create_BtnInputs */

const vi_cdo_create_btn = /** @type {(inputs: Cdo_Create_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn`)
};

/**

* @param {Cdo_Create_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_create_btn = /** @type {((inputs?: Cdo_Create_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Create_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_create_btn(inputs)
});